import { FC } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { formStyles } from "shared/ui";
import { useConfirmEmailChange } from "../model/useConfirmEmailChange";

import styles from "./ConfirmEmailChangePage.module.css";

const MISSING_TOKEN_MESSAGE = "Invalid or missing confirmation link.";

export const ConfirmEmailChangePage: FC = () => {
  const history = useHistory();
  const { search } = useLocation();
  const token = new URLSearchParams(search).get("token") ?? "";
  const { isConfirming, isConfirmed, error } = useConfirmEmailChange(token);

  const errorMessage = token ? error : MISSING_TOKEN_MESSAGE;

  return (
    <div className={styles.container}>
      <div className={`${formStyles.form} ${styles.card}`}>
        <h2 className={styles.title}>Email confirmation</h2>
        {isConfirming && (
          <p className={formStyles.status}>Confirming your new email...</p>
        )}
        {isConfirmed && (
          <p className={formStyles.status}>Your email has been changed.</p>
        )}
        {errorMessage && <p className={formStyles.error}>{errorMessage}</p>}
        {!isConfirming && (
          <button
            type="button"
            className={formStyles.submitButton}
            onClick={() => history.push("/")}
          >
            Continue
          </button>
        )}
      </div>
    </div>
  );
};
